import React from 'react'
import InfoCard from '../../../components/common/InfoCard/InfoCard'
import AimIcon from '../../../assets/aim.png'
import MissionIcon from '../../../assets/rocketIcon.png'
import VisionIcon from '../../../assets/pinIcon.png'
import GreenIcon from '../../../assets/greenPin.png'
import { useAuthStore } from '../../../store/authStore'

const Offerings: React.FC = () => {
  const { language } = useAuthStore()

  return (
    <div
      className="w-full"
      style={{
        background:
          'linear-gradient(to bottom, #FFDFB740 0%, #FFDFB740 20%, #fff 40%, #fff 100%)',
      }}
    >
      <div className="py-10 w-11/12 mx-auto">
        <div className=" mb-8">
          <h2 className="text-2xl font-bold font-Barlow">
            {language === 'lang_mal' ? 'ഞങ്ങളുടെ സേവനങ്ങൾ' : 'Our Services'}
          </h2>
          <p className="text-md text-gray-600">
            {language === 'lang_mal'
              ? 'ഞങ്ങൾ നിങ്ങളുടെ ഏറ്റവും പ്രധാനപ്പെട്ട ബിസിനസ് വെല്ലുവിളികളെ അഭിമുഖീകരിക്കാൻ രൂപകല്‍പന ചെയ്ത സമഗ്രമായ പ്രൊഫഷണൽ സേവനങ്ങളുടെ ഒരു സമാഹാരം നൽകുന്നു.'
              : 'We offer an integrated suite of professional services designed to address your most critical business challenges.'}
          </p>
        </div>
        {/* <div className="grid gap-12 justify-center grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
          {offeringsData.map((item, index) => (
            <OfferingCard
              key={index}
              image={item.image}
              title={item.title}
              subtitle={item.subtitle}
              content={item.content}
            />
          ))}
        </div> */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full text-justify">
          {/* <InfoCard
            iconSrc={AimIcon}
            title="Trainings"
            content="EDC values inclusivity, excellence, and adaptability with empowering entrepreneurs to build smart, responsible, and resilient businesses for Kerala’s future."
            textColor="text-darkPrimaryBlue"
          />
          <InfoCard
            iconSrc={MissionIcon}
            title="Facilitation services"
            content="Our mission is to cultivate a dynamic local environment for businesses by utilizing global knowledge through collaboration to drive local growth and development."
            textColor="text-titleBorder"
          />
          <InfoCard
            iconSrc={VisionIcon}
            title="Industry-Academic Collaborations"
            content="Our vision is to become a hub of excellence in executing the development of smart and sustainable enterprises throughout the state."
            textColor="text-buttonYellow"
          />
          <InfoCard
            iconSrc={GreenIcon}
            title="Technology Transfer"
            content="Our vision is to become a hub of excellence in executing the development of smart and sustainable enterprises throughout the state."
            textColor="text-LeafGreen"
          /> */}
          <InfoCard
            iconSrc={AimIcon}
            title={language === 'lang_mal' ? 'പരിശീലനങ്ങൾ' : 'Trainings'}
            content={
              language === 'lang_mal'
                ? 'EDC ഉൾപ്പെടുത്തലും, മികച്ചതും, അനുയോജ്യതയും പ്രാധാന്യമർഹിക്കുന്ന സംരംഭകരെ കേരളത്തിന്റെ ഭാവിക്കായി ബുദ്ധിമുട്ടില്ലാത്ത, ഉത്തരവാദിത്വമുള്ള, പ്രതിരോധ ശേഷിയുള്ള ബിസിനസുകൾ നിർമ്മിക്കാൻ ശാക്തീകരിക്കുന്നു.'
                : 'EDC values inclusivity, excellence, and adaptability with empowering entrepreneurs to build smart, responsible, and resilient businesses for Kerala’s future.'
            }
            textColor="text-darkPrimaryBlue"
          />

          <InfoCard
            iconSrc={MissionIcon}
            title={
              language === 'lang_mal'
                ? 'സഹായ സേവനങ്ങൾ'
                : 'Facilitation services'
            }
            content={
              language === 'lang_mal'
                ? 'സ്വദേശം വളർച്ചയും വികസനവും മുന്നോട്ടു കൊണ്ടുവരാൻ സഹകരണം വഴി ആഗോള അറിവ് പ്രയോഗിച്ച് ബിസിനസുകൾക്ക് ഒരു സജീവമായ പരിസ്ഥിതി ഒരുക്കുന്നതാണ് നമ്മുടെ ദൗത്യം.'
                : 'Our mission is to cultivate a dynamic local environment for businesses by utilizing global knowledge through collaboration to drive local growth and development.'
            }
            textColor="text-titleBorder"
          />

          <InfoCard
            iconSrc={VisionIcon}
            title={
              language === 'lang_mal'
                ? 'ഇന്ത്യസര-അക്കാദമിക് സഹകരണങ്ങൾ'
                : 'Industry-Academic Collaborations'
            }
            content={
              language === 'lang_mal'
                ? 'സംസ്ഥാനത്താകെ സ്മാർട്ട് ആൻഡ് സുസ്ഥിര എന്റർപ്രൈസുകളുടെ വികസനം നടത്തുന്നതിൽ എക്സലൻസ് ഹബ് ആകാൻ നമ്മുടെയത് ദർശനമാണ്.'
                : 'Our vision is to become a hub of excellence in executing the development of smart and sustainable enterprises throughout the state.'
            }
            textColor="text-buttonYellow"
          />

          <InfoCard
            iconSrc={GreenIcon}
            title={
              language === 'lang_mal'
                ? 'ടെക്‌നോളജി ട്രാൻസ്ഫർ'
                : 'Technology Transfer'
            }
            content={
              language === 'lang_mal'
                ? 'സംസ്ഥാനത്താകെ സ്മാർട്ട് ആൻഡ് സുസ്ഥിര എന്റർപ്രൈസുകളുടെ വികസനം നടത്തുന്നതിൽ എക്സലൻസ് ഹബ് ആകാൻ നമ്മുടെയത് ദർശനമാണ്.'
                : 'Our vision is to become a hub of excellence in executing the development of smart and sustainable enterprises throughout the state.'
            }
            textColor="text-LeafGreen"
          />
        </div>
      </div>
    </div>
  )
}

export default Offerings
